//  ==========================================================================
//
//  Location (detail page)
//
//  ==========================================================================
import React, { PureComponent } from 'react';

import { graphql } from 'gatsby';

import classnames from 'classnames';
import striptags from 'striptags';

import {
	MetaTags,
	HeroTitleOverlay,
	GridLocationDetail,
	PortfolioBanner,
	VideoEmbed,
} from '../../components';

import {
	detailPageServiceQuickLinks,
	normalizeLocationBase,
} from '../../helpers';

//  ==========================================================================
//  Component
//  ==========================================================================
export default class Location extends PureComponent {
	constructor( props ) {
		super( props );

		this._locationInfo = normalizeLocationBase(
			this.props.data.wordsbyCollections
		);

		this._locationSlug = this._locationInfo?.slug;

		const encodedPostTitle = 'string' === typeof( this._locationInfo?.slug )
			? encodeURIComponent( this._locationInfo.slug )
			: '';

		this._ctaLinks = [
			{
				name: `Meet Our ${this._locationInfo.post_title} Team`,
				path: `/search?contentTypes=people&locations=${encodedPostTitle}`,
			},
		];
	}

	render() {
		const {
			hero,
			post_title,
			description,
			business_contact,
			short_summary,
			addresses,
			phone,
			video,
			grid,
			grid_heading,
			yoast,
		} = this._locationInfo;

		const classes = classnames( `location location--${this._locationSlug}` );
		
		return (
			<main id="main" className={classes}>
				<MetaTags
					post_title={post_title}
					description={striptags( short_summary )}
					ogImage={hero?.imageAttachment?.file_url}
					yoast={yoast}
				/>

				<HeroTitleOverlay
					hero={hero}
					eyebrow="Locations"
					post_title={post_title}
					description={description}
					link="#" // TODO: add search link: search content type “Case Studies” and project type “[Project Type Title]”
					contact={business_contact.length ? business_contact[0] : null}
					quickLinks={detailPageServiceQuickLinks}
					location={true}
					locationDetails={addresses}
					phone={phone}
					ctaLinks={this._ctaLinks}
				/>

				<section className="content-contain overflow-hidden">
					{video && <VideoEmbed video={video} />}
					{!!grid && !!grid_heading && (
						<GridLocationDetail
							curatedContentTitle={grid_heading}
							curatedContent={grid}
						/>
					)}
				</section>

				{!!business_contact[0] && (
					<PortfolioBanner
						link="#"
						projectType={post_title}
						contact={business_contact[0]}
						type="location"
					/>
				)}
			</main>
		);
	}
}

export const locationQuery = graphql`
	query LocationByID($id: Int!) {
		wordsbyCollections(ID: { eq: $id }) {
			...PostFields
			...HeroComponent
			...ThumbnailFields

			business_contact {
				relationshipByID {
					...PersonFragment
				}
			}
			addresses {
				building_name
				address_1
				address_2
				map_url
			}
			phone
			description
			region
			short_summary
			video
			grid_heading
			grid {
				relationshipByID {
					...CardComponent
					...QuoteComponent
				}
				post_type
				post_status
			}
		}
	}
`;
